import { Box, CircularProgress } from '@mui/material';

const AppLoader = () => {
  return (
    <Box
      height='100vh'
      display='flex'
      alignItems='center'
      justifyContent='center'
    >
      <CircularProgress />
    </Box>
  );
};

export default AppLoader;
